import React from 'react';
import { Badge } from 'reactstrap';
import { useTranslator } from '@front-activerse/common-components';
import type { WearableProviderStatus } from './types';

interface Props {
  status: WearableProviderStatus;
}

const statusColorMap: Record<WearableProviderStatus, string> = {
  PENDING: 'warning',
  ACTIVE: 'success',
  REVOKED: 'secondary',
  EXPIRED: 'warning',
  ERROR: 'danger',
  COMING_SOON: 'light',
};

const statusKeyMap: Record<WearableProviderStatus, string> = {
  PENDING: 'wearables.status.connecting',
  ACTIVE: 'wearables.status.connected',
  REVOKED: 'wearables.status.disconnected',
  EXPIRED: 'wearables.status.expired',
  ERROR: 'wearables.status.error',
  COMING_SOON: 'wearables.status.comingSoon',
};

const ConnectionStatus: React.FC<Props> = ({ status }) => {
  const { t } = useTranslator();
  const color = statusColorMap[status] ?? statusColorMap.REVOKED;
  const label = t(statusKeyMap[status] ?? statusKeyMap.REVOKED);
  const className = status === 'COMING_SOON' ? 'badge-coming-soon' : '';
  return (
    <Badge color={color} className={className}>
      {label}
    </Badge>
  );
};

export default ConnectionStatus;
